<template>
  <div class="communities-banner position-relative">
    <div class="height-percent-100 width-percent-100 position-absolute layer-1">
      <div class="communities-banner__background primary">
        <LayoutGutters no-padding>
          <div class="layer-3 inverted--text py-12 pl-md-0">
            <h1>{{ bannerTitle }}</h1>
            <p
              class="communities-banner__text mt-6 subtitle-2 text-sm-subtitle-1"
            >
              {{ bannerText }}
            </p>
          </div>
        </LayoutGutters>
      </div>
      <div
        class="layer-2 position-absolute width-percent-100 height-percent-100 top-0 right-0"
      >
        <div
          class="communities-banner__image"
          :style="{ backgroundImage: `url('${bannerImage}')` }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LayoutGutters from "~/components/layout/LayoutGutters.vue";

export default {
  name: "CommunitiesBanner",
  components: { LayoutGutters },

  props: {
    bannerTitle: { type: String, default: undefined },
    bannerText: { type: String, default: undefined },
  },
  computed: {
    ...mapState({
      images: (state) => state.theme.images.publicDashboard,
    }),
    bannerImage() {
      return this.images.bannerImage;
    },
  },
};
</script>

<style lang="scss">
.communities-banner {
  height: 300px;
  @include media-breakpoint-up("md") {
    height: 260px;
  }

  &__background {
    border-bottom: 4px solid #f3bd48;
  }

  &__text {
    max-width: 310px;
    @include media-breakpoint-up("md") {
      max-width: 595px;
    }
  }

  &__image {
    height: 100%;
    width: 100%;

    background-size: auto 840px;
    background-position-x: calc(100vw - 344px);
    background-position-y: -350px;

    @include media-breakpoint-up("sm") {
      background-size: auto 1093px;
      background-position-x: calc(100vw - 500px);
      background-position-y: -475px;
    }
    @include media-breakpoint-up("md") {
      background-size: auto 1214px;
      background-position-x: calc(100vw - 603px);
      background-position-y: -575px;
    }
    @include media-breakpoint-up("lg") {
      background-size: auto 1381px;
      background-position-x: calc(100vw - 837px);
      background-position-y: -675px;
    }
    @include media-breakpoint-up("xl") {
      background-size: auto 1493px;
      background-position-x: calc(100vw - 1055px);
      background-position-y: -635px;
    }
  }
}
</style>
